import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";





function Pifelse(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()
    
    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  




return(
     <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python If Else Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python ifelse tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and questions of all technology like Python tutorial, Python tutorial,Python tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Python ifelse,Python if else statement,
python if else,python if else one line,python if else in one line,python if else if,python if else syntax,python if else example,python if without else,Python if else example,Python if else syntax,Python if else statement example" />
<link rel="canonical" href="https://www.codeexampler.com/python-if-else" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Python if-else Statement</h1>

    <div className="first">
        <a href="/python-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-if-else-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

    <h2 className="mt-4 mh2">Python if-else statement Syntax:</h2>



       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-6">if</span>
                <span className="qwerty-1">(</span>
                <span className="qwerty-4">condition</span>
                <span className="qwerty-1">)</span>
                <span className="qwerty-1">:</span>
            {"\n"}
                <span className="qwerty-3">   statement</span>
            {"\n"}
                <span className="qwerty-6">else</span>
                <span className="qwerty-1">:</span>
            {"\n"}
                <span className="qwerty-3">   statement</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>   



<h2 className='headings'>Q-Write a program to input a number and check this value is more significant than 1000 or not in the python tutorial?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
            <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-10">Enter the value of a:</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
             <span className="qwerty-4">a</span>
                 <span className="qwerty-9"> = </span>
                 <span className="qwerty-5">int</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-8">input</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                <span className="qwerty-6">if</span>
                <span className="qwerty-1">(</span>
                <span className="qwerty-4">a</span>
                <span className="qwerty">&#62;</span>
                <span className="qwerty-8">1000</span>
                <span className="qwerty-1">)</span>
                <span className="qwerty-1">:</span>
            {"\n"}
            <span className="qwerty-3">    print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty">a </span>
                 <span className="qwerty-10">is greater than 1000</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                <span className="qwerty-6">else</span>
                <span className="qwerty-1">:</span>
            {"\n"}
            <span className="qwerty-3">    print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty">a </span>
                 <span className="qwerty-10">is less than 1000</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-1">)</span>  
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div> 
        <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"100vh"}}>
                 <code >
                 {"\n"}
                         <span className="qwerty-8">Enter the value of a: </span>
                     {"\n"}
                         <span className="qwerty-3">160208</span>
                         {"\n"}    
                         <span className="qwerty">a</span>
                         <span className="qwerty-4"> is greater than 1000</span>
                         {"\n"}    
                         {"\n"}    
               </code>
                 </pre>
                 </div>  


<p className="mt-4 para">If you don't know about input in Python so check on <a href="https://www.codeexampler.com/python-list"> Python list tutorial</a></p>


<h2 className='headings'>Q-Write a program to checka no is even or odd in the python tutorial?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
             <span className="qwerty-3">print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Enter the value of a:</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-4">a</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-5">int</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-8">input</span>
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-6">)</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-6">if</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">%</span>
                 <span className="qwerty-8">2</span>
                 <span className="qwerty">==</span>
                 <span className="qwerty-8">0</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">even</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-6">else</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">odd</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-8">Enter the value of a: </span>
                      {"\n"}
                          <span className="qwerty-3">16</span>
                          {"\n"}    
                          <span className="qwerty-4">even</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div> 



<h2 className='headings'>Q-Write a program to check a given alphabet is vowels by using character?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
             <span className="qwerty-3">print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Enter any alphabet:</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-4">vowel</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-8">input</span>
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-6">)</span>
              {"\n"}
                 <span className="qwerty-6">if</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">vowel</span>
                 <span className="qwerty">==</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-8">a</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-5">or </span>
                 <span className="qwerty-4">vowel</span>
                 <span className="qwerty">==</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-8">e</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-5">or </span>
                 <span className="qwerty-4">vowel</span>
                 <span className="qwerty">==</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-8">i</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-5">or </span>
                 <span className="qwerty-4">vowel</span>
                 <span className="qwerty">==</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-8">o</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-5">or </span>
                 <span className="qwerty-4">vowel</span>
                 <span className="qwerty">==</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-8">u</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">vowels</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-6">else</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">not</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>   
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-8">Enter any alphabet: </span>
                      {"\n"}
                          <span className="qwerty-3">o</span>
                          {"\n"}    
                          <span className="qwerty-4">vowels</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>

<h2 className='headings'>Q-Write a program to find out which no is greater between two numbers?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
              {"\n"}
              <span className="qwerty-4">a</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-8">40</span>
                  <span className="qwerty-1">;</span>
              <span className="qwerty-4">b</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-8">50</span>
                  <span className="qwerty-1">;</span>
              {"\n"}
                 <span className="qwerty-6">if</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">greater = </span>
                  <span className="qwerty-1">",</span>
                  <span className="qwerty-4">a</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-6">else</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">greater = </span>
                  <span className="qwerty-1">",</span>
                  <span className="qwerty-4">b</span>
                  <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-8">Greater = </span>
                          <span className="qwerty-3">50</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>   


<h2 className='headings'>Q-Write a program to find out the capital of India?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
              {"\n"}
              <span className="qwerty-4">a</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-8">input</span>
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Enter the capital of India:</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-6">)</span>
              {"\n"}
                 <span className="qwerty-6">if</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">==</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-8">Delhi</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Correct</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-6">else</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Incorrect</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-8">Enter the capital of India: </span>
                      {"\n"}
                          <span className="qwerty-3">Delhi</span>
                          {"\n"}    
                          <span className="qwerty-4">Correct</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>    

<h2 className="mt-4 mh2">Search in Python: </h2>



<h2 className='headings'>Q-Write a program to find out a character in a string in Python?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
             <span className="qwerty-4">c</span>
                  <span className="qwerty-1">=</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">India,USA,UK</span>
                  <span className="qwerty-1">"</span>
              {"\n"}
                 <span className="qwerty-6">if</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-5">t</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty"> in </span>
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Present</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-6">else</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Not Present</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>   
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-4">Not Present</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>   



<h2 className='headings'>Q-Write a program to find out leap year?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
             <span className="qwerty-3">print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Enter a year:</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-4">a</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-5">int</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-8">input</span>
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-6">)</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-6">if</span>
                 <span className="qwerty-4"> a</span>
                 <span className="qwerty">%</span>
                 <span className="qwerty-8">400</span>
                 <span className="qwerty">==</span>
                 <span className="qwerty-4">0</span>
                 <span className="qwerty-5"> or </span>
                 <span className="qwerty-4"> a</span>
                 <span className="qwerty">%</span>
                 <span className="qwerty-8">4</span>
                 <span className="qwerty">==</span>
                 <span className="qwerty-8">0</span>
                 <span className="qwerty-5"> and </span>
                 <span className="qwerty-4"> a</span>
                 <span className="qwerty">%</span>
                 <span className="qwerty-8">100</span>
                 <span className="qwerty">!=</span>
                 <span className="qwerty-8">0</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">LEAP YEAR</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-6">else</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">NO LEAP YEAR</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>      
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-8">Enter the year: </span>
                      {"\n"}
                          <span className="qwerty-3">2001</span>
                          {"\n"}    
                          <span className="qwerty-4">NO LEAP YEAR</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>  

<h2 className='headings'>Q-Write a program to enter your name and check string is empty or not?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
              <span className="qwerty-4">str</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-8">input</span>
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Enter your name:</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-6">)</span>
              {"\n"}
                 <span className="qwerty-6">if</span>
                 <span className="qwerty-4"> str</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Hello Mr </span>
                  <span className="qwerty-1">",</span>
                  <span className="qwerty-4">str</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-6">else</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Empty</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>                    {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-8">Enter your name: </span>
                      {"\n"}
                          <span className="qwerty-3">CodeExampler</span>
                          {"\n"}    
                          <span className="qwerty-4">Hello Mr</span>
                          <span className="qwerty-2"> CodeExampler</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div> 





<h2 className='headings'>Q-Write a program to find out students pass or fail in 3 subjects in Python Code?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
              <span className="qwerty-4">e</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-2">int</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-8">input</span>
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Enter 1 subject :</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-6">)</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-4">f</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-2">int</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-8">input</span>
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Enter 2 subject :</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-6">)</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-4">g</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-2">int</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-8">input</span>
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Enter 3 subject :</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-6">)</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-6">if</span>
                 <span className="qwerty-4"> e</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-8">40</span>
                 <span className="qwerty-5"> and </span>
                 <span className="qwerty-4">f</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-8">50</span>
                 <span className="qwerty-5"> and </span>
                 <span className="qwerty-4">g</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-8">60</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">PASS</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-6">else</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">FAIL</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>      
                             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-8">Enter 1 subject : </span>
                          <span className="qwerty-3">64</span>
                          {"\n"}    
                          <span className="qwerty-8">Enter 2 subject : </span>
                          <span className="qwerty-3">86</span>
                          {"\n"}    
                          <span className="qwerty-8">Enter 3 subject : </span>
                          <span className="qwerty-3">94</span>
                          {"\n"}    
                          <span className="qwerty-4">PASS</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>   










<h3 className="mt-4">Nested list in python Tutorial:</h3>



<h2 className='headings'>Q-Write a program to input a no and check whether  the input no is greater than 1000 or less than 100 or in between?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
              {"\n"}
              <span className="qwerty-4">i</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-5">int</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-8">input</span>
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Enter the value of a:</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-6">)</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-6">if</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">i</span>
                 <span className="qwerty">&#60;</span>
                 <span className="qwerty-8">100</span>
                  <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">no is less than </span>
                  <span className="qwerty-8">100</span>
                  <span className="qwerty-1">")</span>
              {"\n"}
                 <span className="qwerty-6">elif</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">i</span>
                 <span className="qwerty">&#62;=</span>
                 <span className="qwerty-8">1000</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">no greater than </span>
                  <span className="qwerty-8">1000</span>
                  <span className="qwerty-1">")</span>
              {"\n"}
                 <span className="qwerty-6">else</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">between</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>             {"\n"}
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-8">Enter a number: </span>
                      {"\n"}
                          <span className="qwerty-3">4542</span>
                          {"\n"}    
                          <span className="qwerty-4">no greater than 1000</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>    




<h2 className='headings'>Q-Write a program to check without a logic operator?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
              {"\n"}
              <span className="qwerty-4">sex</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-8">input</span>
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Enter a gender:</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-6">)</span>
              {"\n"}
                 <span className="qwerty-6">if</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">sex</span>
                 <span className="qwerty">==</span>
                  <span className="qwerty-1">"</span>
                 <span className="qwerty-8">male</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">male</span>
                  <span className="qwerty-1">")</span>
              {"\n"}
                 <span className="qwerty-6">elif</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">sex</span>
                 <span className="qwerty">==</span>
                  <span className="qwerty-1">"</span>
                 <span className="qwerty-8">female</span>
                  <span className="qwerty-1">"</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">female</span>
                  <span className="qwerty-1">")</span>
              {"\n"}
                 <span className="qwerty-6">else</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Not male and female</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-1">)</span>             
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-8">Enter a gender: </span>
                      {"\n"}
                          <span className="qwerty-3">female</span>
                          {"\n"}    
                          <span className="qwerty-4">female</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div> 





<h2 className='headings'>Q-Write a program to check without a logic operator?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
             <span className="qwerty-3">print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-4">sale</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-5">int</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-8">input</span>
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Enter a sale:</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-6">)</span>
                 
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-6">if</span>
                 <span className="qwerty-4"> sale</span>
                 <span className="qwerty">&#62;</span>
                 <span className="qwerty-8">10000</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-7">    tax</span>
                  <span className="qwerty-1">=</span>
                  <span className="qwerty-4">sale</span>
                  <span className="qwerty">*</span>
                  <span className="qwerty-2">7</span>
                  <span className="qwerty">/</span>
                  <span className="qwerty-2">100</span>
             {"\n"}
             <span className="qwerty-7">    comm</span>
                  <span className="qwerty-1">=</span>
                  <span className="qwerty-4">sale</span>
                  <span className="qwerty">*</span>
                  <span className="qwerty-2">3</span>
                  <span className="qwerty">/</span>
                  <span className="qwerty-2">100</span>
             
             
              {"\n"}
                 <span className="qwerty-6">else</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-7">    tax</span>
                  <span className="qwerty-1">=</span>
                  <span className="qwerty-4">sale</span>
                  <span className="qwerty">*</span>
                  <span className="qwerty-2">7</span>
                  <span className="qwerty">/</span>
                  <span className="qwerty-2">100</span>
             {"\n"}
             <span className="qwerty-7">    comm</span>
                  <span className="qwerty-1">=</span>
                  <span className="qwerty-4">sale</span>
                  <span className="qwerty">*</span>
                  <span className="qwerty-2">3</span>
                  <span className="qwerty">/</span>
                  <span className="qwerty-2">100</span>
             {"\n"}
             <span className="qwerty-3">print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">tax = </span>
                  <span className="qwerty-5">%d</span>
                  <span className="qwerty-1">"</span>         
                  <span className="qwerty-7">%tax</span>      
                   <span className="qwerty-1">)</span>            
             {"\n"}
             <span className="qwerty-3">print</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">comm = </span>
                  <span className="qwerty-5">%d</span>
                   <span className="qwerty-1">"</span>  
                   <span className="qwerty-7">%comm</span> 
                   <span className="qwerty-1">)</span>             {"\n"}
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-8">Enter a sale: </span>
                          <span className="qwerty-3">4556</span>
                          {"\n"}    
                          <span className="qwerty-4">tax = </span>
                          <span className="qwerty-3">318</span>
                          {"\n"}    
                          <span className="qwerty-4">comm = </span>
                          <span className="qwerty-3">136</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>  

  <h1 className="mt-5">  </h1>

  <div className="back">
        <a href="/python-if">  <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-if-else-if">  <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Pifelse;